import { TradingStatus } from '@ndvr/portfolio-api';

import { titleCase } from 'utils';

export const TRADING_STATUS_ORDER: TradingStatus[] = [
    TradingStatus.REBALANCE_IN_PROGRESS,
    TradingStatus.AUTOMATIC,
    TradingStatus.MANUAL,
    TradingStatus.SUSPENDED,
    TradingStatus.EXTERNAL,
];

export const getTradingStatusLabel = (status: TradingStatus): string => {
    switch (status) {
        case TradingStatus.REBALANCE_IN_PROGRESS:
            return 'Rebalance in Progress';
        case TradingStatus.EXTERNAL:
            return 'Separately Managed';
        default:
            return titleCase(status);
    }
};

export const getTradingStatusColor = (status: TradingStatus): string => {
    switch (status) {
        case TradingStatus.REBALANCE_IN_PROGRESS:
            return 'bg-blue-500';
        case TradingStatus.AUTOMATIC:
            return 'bg-green-500';
        case TradingStatus.MANUAL:
            return 'bg-amber-500';
        case TradingStatus.SUSPENDED:
            return 'bg-red-500';
        case TradingStatus.EXTERNAL:
            return 'bg-gray-300';
    }
};
